<script>
  import CalendarEvent from "./CalendarEvent.svelte";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let weekday;
  export let playday = false;
  export let events;
  export let inactive = false;
  export let today = false;

  function generateEvent() {
    dispatch("createEvent", {
      weekday,
    });
  }

  function eventUpdated(event) {
    dispatch("editEvent", event.detail);
  }
</script>

<div
  class="days {inactive && 'inactive'} {playday && 'playday'} {today &&
    'today'}"
>
  <span class="weekdays" on:dblclick={generateEvent}>{weekday}</span>
  <ul class="events">
    {#if events.length > 0}
      {#each events as event}
        <CalendarEvent {event} on:editEvent={eventUpdated} />
      {/each}
    {/if}
  </ul>
</div>

<style type="text/scss">
  $bg-color: #f9fafb;
  .days {
    padding: 10px;
    padding-top: 0;
    background-color: $bg-color;
    opacity: 0.9;
    border-radius: 5px;
    border-top: 5px solid scale-color($color: $bg-color, $lightness: 10%);
    overflow-y: scroll;

    display: grid;
    grid-template-rows: 1fr 5fr;
    grid-template-columns: 1fr;

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .weekdays {
      position: sticky;
      top: 0;
      background-color: $bg-color;
      display: block;
      padding: 3px;
      padding-left: 10px;
      z-index: 90;
    }

    &:hover {
      opacity: 1;
      border-top: 5px solid scale-color($color: $bg-color, $lightness: 40%);
    }

    &.inactive {
      opacity: 0.4;
      transition: opacity 200ms;

      .weekdays {
        color: darkgrey;
      }

      &:hover {
        opacity: 1;
      }
    }

    &.playday {
      border-top: 5px solid darkgreen;

      &:hover {
        border-top: 5px solid scale-color($color: darkgreen, $lightness: 10%);
      }
    }

    &.today {
      $todayColor: scale-color(
        $color: $bg-color,
        $lightness: 40%,
      );
      opacity: 1;
      border: 1px solid $todayColor;
      border-bottom: 3px solid $todayColor;

      border-top: 5px solid $todayColor;

      .weekdays {
        text-shadow: 0px 0px 5px rgba(255, 255, 255, 0.63);
      }
    }

    .events {
      margin-top: 5px;
      z-index: 0;
    }
  }
</style>
